<template>
  <b class="text-success">
    (<slot>automatycznie</slot>)
  </b>
</template>

<script>
export default {
  name: 'WAutoText',
  data() {
    return {};
  }
};
</script>

